module.exports = __webpack_public_path__ + "img/helo-bg.d4879793.svg";